import React, { useState } from "react";
import styles from "./kyc.module.scss";

import { FaUser } from "react-icons/fa";
import { LuScanLine } from "react-icons/lu";
import { FaCameraRetro } from "react-icons/fa6";
import { FaTasks } from "react-icons/fa";
import Button from "../../../../components/Button/Button";
import PersonalInformation from "./PersonalInformation";
import IdVerification from "./IdVerification";
import Selfie from "./Selfie";
import Review from "./Review";
import { useSelector } from "react-redux";
import cancelledHourGlass from '../../../../assets/images/extras/hourglass.png'
import pendingHourGlass from '../../../../assets/images/extras/sand-clock.png'
import successImg from '../../../../assets/images/extras/verify.png'
import { useEffect } from "react";

const Kyc = () => {
    const userData = useSelector((state) => state.partner.user);
    console.log("User Data! ", userData);

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        documentCountry: "",
        documentType: "",
        documentNumber: "",
        documentUrl: null,
        documentImg: null,
        selfieUrl: null,
        selfieImg: null,
    });

    useEffect(() => {
        if (userData && userData.partner) {
            setFormData((prevData) => 
                ({ ...prevData, 
                firstName: userData.partner.first_name,
                lastName: userData.partner.last_name,
                phoneNumber: userData.partner.contact_number,
                email: userData.email 
            }))
        }
    }, [userData])

    const handleInputChange = (event) => {
        console.log("Event: ", event.target.name, event.target.value);

        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setFormData((prevData) => ({
                        ...prevData,
                        [name]: file,
                    }));
                };
                reader.readAsDataURL(file);
            }
        } else {
            setFormData((prevData) => ({ ...prevData, [name]: value }));
        }
    };
    const [activeNav, setActiveNav] = useState(1);
    const kycNav = [
        {
            id: 1,
            label: "Personal Information",
            subLabel: "Fill your personal information",
            icon: <FaUser />,
            form: (
                <PersonalInformation
                    formData={formData}
                    setFormData={setFormData}
                    setActiveNav={setActiveNav}
                    handleInputChange={handleInputChange}
                />
            ),
        },
        {
            id: 2,
            label: "ID Verification",
            subLabel: "Fill your ID details",
            icon: <LuScanLine />,
            form: (
                <IdVerification
                    formData={formData}
                    setFormData={setFormData}
                    setActiveNav={setActiveNav}
                    handleInputChange={handleInputChange}
                />
            ),
        },
        {
            id: 3,
            label: "Selfie",
            subLabel: "Include or upload a selfie",
            icon: <FaCameraRetro />,
            form: (
                <Selfie
                    formData={formData}
                    setFormData={setFormData}
                    setActiveNav={setActiveNav}
                    handleInputChange={handleInputChange}
                />
            ),
        },
        {
            id: 4,
            label: "Review",
            subLabel: "Review your Information",
            icon: <FaTasks />,
            form: (
                <Review
                    formData={formData}
                    setFormData={setFormData}
                    setActiveNav={setActiveNav}
                />
            ),
        },
    ];

    const verificationStatus = {

        'pending':
        {
            title: 'Pending',
            description: '    Your KYC documents have been submitted successfully and are currently under review. Our verification team is working diligently to validate your information.',
            imgUrl: pendingHourGlass
        },
        'rejected': {
            title: 'Rejected',
            description: userData?.partner?.kyc?.verification_notes,
            imgUrl: cancelledHourGlass
        },
        'success':
        {
            title: 'Success',
            description: userData?.partner?.kyc?.verification_notes,
            imgUrl: successImg
        }
    }

    return userData?.partner.kyc === null ? (
        <div className={styles.kycContainer}>
            <div className={styles.pageHeader}>
                <h2 className={styles.pageHeading}>KYC Verification</h2>
                <p className={styles.pageSubHeading}>
                    Verify your Identity to get started.
                </p>
            </div>

            <div className={styles.pageBody}>
                <div className={styles.sideBar}>
                    <ul className={styles.navList}>
                        {kycNav.map((nav) => (
                            <li
                                key={nav.id}
                                className={`${styles.nav} ${activeNav === nav.id ? styles.activeNav : ""
                                    }`}
                                onClick={() => {
                                    setActiveNav(nav.id);
                                }}
                            >
                                <div
                                    className={`${styles.icon} ${activeNav === nav.id ? styles.activeIcon : ""
                                        }`}
                                >
                                    {nav.icon}
                                </div>
                                <div className={styles.navDetails}>
                                    <h4>{nav.label}</h4>
                                    <p>{nav.subLabel}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={styles.content}>
                    {kycNav
                        .filter((kyc) => kyc.id === activeNav)
                        .map((kyc) => (
                            <div key={kyc.id}>
                                <div className={styles.formHeader}>
                                    <h3 className={styles.stepMark}>Step: {kyc.id}</h3>
                                    <h2 className={styles.stepheading}>{kyc.label}</h2>
                                    <p className={styles.stepSubHeading}>{kyc.subLabel}</p>
                                </div>
                                {kyc.form}
                            </div>
                        ))}
                </div>
            </div>
        </div>
    ) : (
        <div className={styles.submittedContainer}>
            {
                userData &&
                <>
                    <div className={styles.kycStatusMedia}>
                        <img src={verificationStatus[userData?.partner?.kyc.verification_status].imgUrl} alt="" />
                    </div>
                    <div className={styles.kycStatusContent}>
                        <h2>
                            Verification {verificationStatus[userData?.partner?.kyc.verification_status].title}!
                        </h2>
                        <p>
                            {verificationStatus[userData?.partner?.kyc.verification_status].description}
                        </p>
                    </div>
                </>
            }

        </div>
    )
};

export default Kyc;
